export enum ApprobationEmailDialogFormNamesEnum {
  FORM_NAME = 'ApprobationEmailDialog',
  EMAIL = 'Email',
}
